import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostMunicipalities_municipalityIdImage = z.any()
export type TagsPostMunicipalities_municipalityIdImage = z.infer<typeof tagsPostMunicipalities_municipalityIdImage>

export const consumesPostMunicipalities_municipalityIdImage = z.any()
export type ConsumesPostMunicipalities_municipalityIdImage = z.infer<typeof consumesPostMunicipalities_municipalityIdImage>

export const paramsPostMunicipalities_municipalityIdImage = z.object({ "municipalityId": z.string() })
export type ParamsPostMunicipalities_municipalityIdImage = z.infer<typeof paramsPostMunicipalities_municipalityIdImage>

export const bodyPostMunicipalities_municipalityIdImage = z.object({ "image": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string(), "file": z.any(), "type": z.string().optional() }) })
export type BodyPostMunicipalities_municipalityIdImage = z.infer<typeof bodyPostMunicipalities_municipalityIdImage>

export const responsePostMunicipalities_municipalityIdImage = z.object({ "payload": z.object({ "id": z.string(), "image": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostMunicipalities_municipalityIdImage = z.infer<typeof responsePostMunicipalities_municipalityIdImage>

interface IPostMunicipalities_municipalityIdImage extends BaseMethodType {
  tags: TagsPostMunicipalities_municipalityIdImage,
  consumes: ConsumesPostMunicipalities_municipalityIdImage,
  params: ParamsPostMunicipalities_municipalityIdImage,
  body: BodyPostMunicipalities_municipalityIdImage,
  response: ResponsePostMunicipalities_municipalityIdImage
}
export const tagsGetMunicipalities_municipalityIdImage = z.any()
export type TagsGetMunicipalities_municipalityIdImage = z.infer<typeof tagsGetMunicipalities_municipalityIdImage>

export const paramsGetMunicipalities_municipalityIdImage = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityIdImage = z.infer<typeof paramsGetMunicipalities_municipalityIdImage>

export const responseGetMunicipalities_municipalityIdImage = z.any()
export type ResponseGetMunicipalities_municipalityIdImage = z.infer<typeof responseGetMunicipalities_municipalityIdImage>

interface IGetMunicipalities_municipalityIdImage extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdImage,
  params: ParamsGetMunicipalities_municipalityIdImage,
  response: ResponseGetMunicipalities_municipalityIdImage
}
export const URL = '/municipalities/:municipalityId/image'
export const validation = {
  post: {
    tags: tagsPostMunicipalities_municipalityIdImage,
    consumes: consumesPostMunicipalities_municipalityIdImage,
    params: paramsPostMunicipalities_municipalityIdImage,
    body: bodyPostMunicipalities_municipalityIdImage,
    response: responsePostMunicipalities_municipalityIdImage
  },
  get: {
    tags: tagsGetMunicipalities_municipalityIdImage,
    params: paramsGetMunicipalities_municipalityIdImage,
    response: responseGetMunicipalities_municipalityIdImage
  }
}
export interface Municipalities_municipalityIdImage extends BaseRouteType {
  post: IPostMunicipalities_municipalityIdImage,
  get: IGetMunicipalities_municipalityIdImage
}